import { Link } from 'react-router-dom';
import SocialMediaLinks from './SocialMediaLinks';

export default function Header() {
  return (
    <header className="bg-purple-800 p-4">
      <div className="container mx-auto flex justify-between items-center">

        <h1>
          <Link to="/" className="text-xl font-bold text-white inline-block no-underline transition duration-300 hover:text-purple-300 hover:scale-105">
            Madhouse Miners ⛏️ 🦄
          </Link>
        </h1>
        <h1 className="font-bold">
          📢 WHITELIST COMING SOON! 📢
        </h1>
        <nav className="flex items-center space-x-6">
          <SocialMediaLinks />
        </nav>
      </div>
    </header>
  );
}

